import Link from 'next/link';

export function MarketingBrand() {
  return (
    <Link href="/" className="marketing-brand" aria-label="PlotsAlot home">
      <svg viewBox="0 0 28 28" fill="none" aria-hidden="true">
        <path d="M5 22V13" stroke="#a38be8" strokeWidth="3" strokeLinecap="round" />
        <path d="M11 22V6" stroke="#ee91ab" strokeWidth="3" strokeLinecap="round" />
        <path d="M17 22V10" stroke="#efa64a" strokeWidth="3" strokeLinecap="round" />
        <path d="M23 22V3" stroke="#689be0" strokeWidth="3" strokeLinecap="round" />
      </svg>
      <span>
        PlotsAlot<span className="marketing-brand-dot">.</span>
      </span>
    </Link>
  );
}
